<script setup lang="ts">

import type { TabProps } from "@/dsComponents/Tab/types";

import TabItem from "@/dsComponents/Tab/TabItem.vue";
import VerticalSeparator from "@/dsComponents/VerticalSeparator.vue";

const props = withDefaults(defineProps<TabProps>(), {
    borderBottom: true,
    noPadding: false,
});

const emit = defineEmits(["select:tab"]);
</script>

<template>
    <div :class="['ds-tab', { 'border-bottom': props.borderBottom, 'no-padding': props.noPadding }]" :style="{padding: props.innerPadding ?? ''}">
        <div
            v-for="(tabGroup, index) in props.tabGroups"
            :key="`tab-group__${index}`"
            :class="['ds-tab-group', { 'ds-tab-group--align-right': tabGroup.alignRight }]"
        >
            <TabItem v-for="tabItem in tabGroup.tabItems" :key="`tab-item__${tabItem.id}`" v-bind="tabItem" @click="emit('select:tab', tabItem.id)" />
            <VerticalSeparator v-if="tabGroup.verticalSeparator" height="16px" />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.ds-tab {
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
    gap: var(--spacing-md, 8px);
    max-width: 100%;
    padding: 0 var(--spacing-4xl, 32px);

    &.border-bottom {
        border-bottom: 1px solid var(--stroke-soft-200, #dbdfe6);
    }

    &.no-padding {
        padding: 0;
    }

    &-group {
        display: flex;
        align-items: stretch;
        justify-content: flex-start;
        gap: var(--spacing-md, 8px);
        align-items: center;

        &--align-right {
            margin-left: auto;
        }
    }
}
</style>
